import { module } from 'modujs';
import { Datepicker , DateRangePicker } from "vanillajs-datepicker";



export default class extends module {
    constructor(m) {
        super(m);
        this.button = this.$( 'button' )[0];
        this.fromDate = this.$( 'from-date' )[0];
        this.toDate = this.$( 'to-date' )[0];
        this.guests = this.$( 'guests' )[0];

        if( this.el.dataset.roomCode ) {
            this.roomCode = '&room=' + this.el.dataset.roomCode;
        }
        else {
            this.roomCode = '';
        }

        this.href = this.button.href;
        this.picker = new DateRangePicker(this.el, { minDate : new Date(), autohide: true, format: 'dd/mm/yyyy' });

        this.fromDate.addEventListener( 'changeDate', () => this.setNights() );
        this.guests.addEventListener( 'input', () => this.setNights() );
        this.toDate.addEventListener( 'input', () => this.setNights() );

        this.setNights();


    }
    setNights() {
       this.nights = Math.floor(( this.picker.dates[1] - this.picker.dates[0]  ) / 1000 / 60 / 60 / 24);
       this.button.href = this.href + '?checkin=' + this.getDate( this.fromDate.value ) + '&nights=' + this.nights + '&adults=' + this.guests.value + this.roomCode;
    }
    getDate( dateString ) {
        let parts = dateString.split('/');
        return parts[2] + '-' + parts[1] + '-' + parts[0];
    }

    init() {}
    destroy(){}
}
